import { CompetencySections } from './CompetencySections';

import type { ReactNode } from 'react';

interface SummaryTabProps {
    /**
     * Whether the company shows its employees their assessed competencies. Closed, the two sections
     * made of them are absent rather than empty: the reader is told nothing about what they cannot
     * see, and the portal never draws "no profile yet" over a company decision.
     */
    areCompetenciesShown: boolean;
    /** The "Reconnaissance" section, drawn last; the portal supplies it. */
    recognitionsSection?: ReactNode;
}

/**
 * The "Sommaire" tab of the employee portal, about the signed-in employee: what they excel at,
 * their evolution journey, then the recognitions they received.
 */
export const SummaryTab = ({ areCompetenciesShown, recognitionsSection }: SummaryTabProps) => (
    <div
        className={'flex flex-col gap-8 md:gap-16'}
        data-testid={'employee-portal-summary'}
    >
        {areCompetenciesShown && <CompetencySections />}
        {recognitionsSection}
    </div>
);
